<template>
  <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
    <div class="col-sm-12 ml-auto">
      <div class="card p-4 rounded-plus bg-faded">
        <h1 class="text-center fw-400 mb-4 d-xs-block">{{ $t('titles.confirm-account') }}</h1>

        <password-form buttonText="buttons.confirm" @setPassword="confirmAccount" />
      </div>
    </div>
  </div>
</template>

<script>
import { authResource } from '@/resources/auth.resource';
import PasswordForm from '@/components/forms/PasswordForm';

// @vuese
// Potwierdzanie konta
// @group Start
export default {
  name: 'ConfirmAccount',
  components: {
    PasswordForm
  },
  methods: {
    // @vuese
    // Potwierdza konto
    confirmAccount({ password }) {
      authResource
        .confirm(this.$route.params.token, password)
        .then(() =>
          this.$store.dispatch('showConfirm', {
            title: 'Konto zostało potwierdzone',
            showCloseButton: false,
            submitButton: 'Ok',
            onSuccess: () => this.$router.push({ name: 'login' })
          })
        )
        .catch(() => this.$store.dispatch('notifyError', { title: 'messages.auth.confirmError' }));
    }
  }
};
</script>
